import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import TabBar from '../../../../../components/TabBar';
import AllStandingsV3 from './AllStandings';

import { createTypeByIdDict } from '../../../../../utils/formatting';
import { getDrawName } from '../../../../../utils/courtSchedular';
import * as eventProfileActions from '../../../../../actions/event-profile-actions';

import styles from '../../../event.scss';
import { sportTypeIds } from '../../../../../utils/eventConstants';
import { drawShape, eventShape, authShape, drawTagTypeShape } from '../../../../../propTypes';

const ProDrawAllStandingV3 = (props) => {
    const {
        draw,
        drawsList,
        sportTypeId,
        auth,
        isPttEvent,
        event,
        drawTagTypes,
    } = props;

    const dispatch = useDispatch();
    const {
        drawAllStats,
    } = useSelector(({ eventProfile }) => {
        const { drawAllStats } = eventProfile;
        return { drawAllStats };
    });
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { types: { tms: { draw: { drawCategoryTypes } } } } = coreUI;
    const drawCategoryTypesDict = createTypeByIdDict(drawCategoryTypes);

    const allStandingsLoading = drawAllStats.loading;
    const allStandings = drawAllStats.data;

    const [tabs, setTabs] = useState([]);

    const selectedTab = tabs.find((tab) => tab.active);
    const currentDraw = selectedTab?.currentDraw || {};

    const handleTabClick = (ev, i) => {
        const tabsUpdate = tabs.map((tab, j) => (i === j ? { ...tab, active: true } : { ...tab, active: false }));
        setTabs(tabsUpdate);
    };

    const populateTabs = () => {
        const parentDraw = drawsList.find((d) => d.id === draw.id);
        const tabsUpdate = [{
            title: getDrawName(parentDraw, parentDraw, drawCategoryTypesDict),
            showTab: true,
            active: true,
            drawId: draw.id,
            currentDraw: parentDraw,
        }];
        if (draw.proDrawSettings?.qualifierDrawId) {
            const qualifierDraw = parentDraw.childDraws.find((d) => d.id === draw.proDrawSettings.qualifierDrawId);
            if (qualifierDraw) {
                tabsUpdate.push({
                    title: getDrawName(qualifierDraw, draw, drawCategoryTypesDict),
                    showTab: true,
                    active: false,
                    drawId: qualifierDraw.id,
                    currentDraw: qualifierDraw,
                });
            }
        }
        if (draw.proDrawSettings?.preQualifierDrawId) {
            const preQualifierDraw = parentDraw.childDraws.find((d) => d.id === draw.proDrawSettings.preQualifierDrawId);
            if (preQualifierDraw) {
                tabsUpdate.push({
                    title: getDrawName(preQualifierDraw, draw, drawCategoryTypesDict),
                    showTab: true,
                    active: false,
                    drawId: preQualifierDraw.id,
                    currentDraw: preQualifierDraw,
                });
            }
        }

        setTabs(tabsUpdate);
    };

    useEffect(() => {
        populateTabs();
    }, [draw, drawsList]);

    useEffect(() => {
        if (tabs.length > 0) {
            const selectedTab = tabs.find((tab) => tab.active);
            dispatch(eventProfileActions.getDrawAllStats(event.id, selectedTab.drawId));
        }
    }, [tabs]);

    return (
        <div className={`${styles.section} bg-transparent main-content`}>
            <TabBar
                tabs={tabs}
                handleTabClick={handleTabClick}
                eventName="ProDraw All Standings Draws Tab Clicked"
                transparent={true}
                noContainer={true}
                clickCategory="Event Profile"
                clickLocation="Draws Tab"
                data-testid="event-profile.pro-draw-standings.tab-bar"
                disabledTabClick={allStandingsLoading}
            />
            <div className={`container bg-transparent matches`}>
                <div className="row">
                    <div className="col">
                        <AllStandingsV3
                            allStandingsLoading={allStandingsLoading}
                            allStandings={allStandings}
                            sportTypeId={sportTypeId}
                            auth={auth}
                            isPttEvent={isPttEvent}
                            draw={currentDraw}
                            event={event}
                            drawTagTypes={drawTagTypes}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

ProDrawAllStandingV3.propTypes = {
    draw: drawShape,
    drawsList: PropTypes.arrayOf(drawShape),
    sportTypeId: PropTypes.number,
    auth: authShape,
    isPttEvent: PropTypes.bool,
    event: eventShape,
    drawTagTypes: PropTypes.arrayOf(drawTagTypeShape).isRequired,
};

ProDrawAllStandingV3.defaultProps = {
    draw: {},
    drawsList: [],
    sportTypeId: sportTypeIds.tennis,
    auth: {},
    isPttEvent: false,
    event: {},
};

export default ProDrawAllStandingV3;
